<template>
<div class="row mt-3">
  <h3 class="col-12 col-md-6">Asset: {{assetData.name}}</h3> 
  <div class= "col-6 col-md-3">
    <DxButton
      text="Modbus config"
      type="normal"
      width="100%"
      @click="showModBusConf"
    />
  </div>
  <div class= "col-6 col-md-3">
    <DxButton
      text="Save changes"
      type="success"
      width="100%"
      @click="saveAssetChanges"
    />  
  </div>
</div>
<div class="row mt-3">
  <DxForm :form-data="assetData"  label-location="left" :min-col-width="350">
    <DxGroupItem :col-count="2" :min-col-width="350">
      <DxSimpleItem 
        data-field="name" 
        :label="{text:'Name'}"
        :editor-options="{ disabled: true }" 
        />
        <DxSimpleItem 
        data-field="desc"
        :label="{text:'Alias'}" 
        editor-type="dxTextBox"
        :editor-options="{ maxLength: 300 }" 
      />
      <DxSimpleItem 
        data-field="uuid" 
        :label="{text:'Uuid'}"
        editor-type="dxTextBox"
        :editor-options="{ disabled: true, maxLength: 120 }" 
      />
      <DxSimpleItem data-field="isEnabled" editor-type="dxCheckBox" />
      
      <DxSimpleItem 
        data-field="fabricator" 
        editor-type="dxTextBox"
        :editor-options="{ maxLength: 120 }" 
      />
      <DxSimpleItem 
        data-field="model" 
        editor-type="dxTextBox"
        :editor-options="{ maxLength: 120 }" 
      />
      <DxEmptyItem/>


    </DxGroupItem>

  </DxForm>
</div>

<!--<div class="row mt-1" v-if="assetData.compType==81">
  <h3 class="col-12 col-md-6">Advanced settings</h3>
  <BatterySettingsEditor/>
</div>-->
<div class="row mt-1 mb-3" v-if="showSSSettings">
  <div> <h3 class="col-12 col-md-6">Advanced settings</h3> </div>
  <DxDataGrid
    :data-source="SSPointsDS"
    :show-borders="true"
    :show-column-lines="true"
    :column-hiding-enabled="true"
    @row-removed="signalRemoveFromDG">
    <DxEditing :allow-updating="true" :allow-deleting="false" mode="row" />
    <DxPaging :page-size="8"/>
    <!--<DxColumn data-field="signalId" :width="80" :hiding-priority="1" data-type="text" :allow-editing="false" />-->
    <!--<DxColumn data-field="ss_id" :min-width="100" :allow-editing="false" />-->
    <!--<DxColumn data-field="modBusAddrOffset" :allow-editing="false" sort-order="asc" :visible="false"/>-->
    <DxColumn data-field="name" caption="Name (* Mandatory)" :min-width="130" :allow-editing="false" />
    <DxColumn data-field="label" :min-width="270" :allow-editing="false" />
    <DxColumn data-field="units" :width="70" :allow-editing="false" />
    <DxColumn data-field="value" :width="100" data-type='number' />
    <DxColumn data-field="description" :width="500" :allow-editing="false"/>
    <DxColumn
        :group-index="0"
        data-field="group"
      />
  </DxDataGrid>
  
</div>

<div class="row mt-3">
  <h3 class="col-12 col-md-6">Signals for {{assetData.name}}</h3>
  <div class="col-12 col-md-6">
    <DxButton
      text="add signal"
      type="success"
      width="100%"
      @click="showAddSignalForm"
    />
  </div>
</div>
<div class="row mt-1">
  <DxDataGrid
    :data-source="signalDS"
    :show-borders="true"
    :column-hiding-enabled="true"
    @row-removed="signalRemoveFromDG"
    :onRowDblClick="fncSignalDblClick">
    <DxSelection mode="single" />
    <DxEditing :allow-updating="true" :allow-deleting="true" mode="row" />

    <!--<DxColumn data-field="signalId" :width="80" :hiding-priority="1" data-type="text" :allow-editing="false" />-->
    <DxColumn data-field="name" :min-width="100" :allow-editing="false" />
    <DxColumn data-field="signalType" :min-width="80" :lookup="{ dataSource: signalTypeList }" />
    <DxColumn data-field="label" :hiding-priority="0" />
    <DxColumn data-field="isIoT" :hiding-priority="2" data-type="boolean" caption="Is IoT" />
    <DxColumn data-field="isKpi" :hiding-priority="2" data-type="boolean" />
  </DxDataGrid>
</div>

<div v-if="isAddSignalFormVisible">
<DxPopup
  content-template="add-signal-form"
  title="Add a New Signal"
  max-width="1300px"
  max-height="570px"
  :show-close-button="true"
  v-model:visible="isAddSignalFormVisible"
  :hide-on-outside-click="true">
  <template #add-signal-form>
    <DxScrollView width="100%" height="100%" >
      <AddSignalForm ref="signalForm" :assetUuid="assetData.uuid" :assetName="assetData.name" @signal-update="(e)=>{hideAddSignalForm(); refreshSignalGrid(e);}" />
    </DxScrollView>
  </template>            
</DxPopup>
</div>

<DxPopup
  content-template="modbus-config"
  title="Asset ModBus Config"
  max-width="350px"
  max-height="525px"
  :show-close-button="true"
  v-model:visible="isMbConfigVisible"
  :hide-on-outside-click="true">
  <template #modbus-config>
    <DxScrollView width="100%" height="100%" >
      <form @submit.prevent="setModbusConfig">
        <DxForm :form-data="modbusConf"  label-location="left" :min-col-width="350">
          <DxGroupItem :col-count="1" :min-col-width="330">
            <!--<DxSimpleItem data-field="enabled" editor-type="dxCheckBox" />-->
            <DxSimpleItem data-field="ipAddress" editor-type="dxTextBox" :editor-options="{ maxLength: 50 }" >
              <DxRequiredRule message="Ip Adrress is required" />
              <DxPatternRule pattern="^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$" 
                message="Invalid Ip address" />
            </DxSimpleItem>
            <DxSimpleItem data-field="port" editor-type="dxNumberBox" :editor-options="{ max: 65500, min: 1 }" >
              <DxRequiredRule message="A port number is required" />
            </DxSimpleItem>
            <DxSimpleItem data-field="unitId" editor-type="dxNumberBox" :editor-options="{ max: 255, min: 0 }" />
            <DxSimpleItem data-field="multpleWordEndianess" :caption="{label:'Multiple-word Endianess'}" editor-type="dxSelectBox" :editor-options="{ items:['Big-Endian','Little-Endian'] }" />
            <DxSimpleItem data-field="cycleReadPeriodMS" :caption="{label:'Cycle Read Period (ms)'}" editor-type="dxNumberBox"  />
            <DxSimpleItem data-field="readOpWaitMS" :caption="{label:'Read Operation Wait (ms)'}" editor-type="dxNumberBox"  />
            <DxEmptyItem/>
          </DxGroupItem>
          <DxGroupItem :col-count="2" >
            <DxButtonItem :button-options="{ type:'danger', width:'100%', text: 'Clear Config', useSubmitBehavior: false, onClick: clearModbusConfig }" />
            <DxButtonItem :button-options="{ type:'success', width:'100%', text: 'Save Changes', useSubmitBehavior: true }" />
          </DxGroupItem>
        </DxForm>
      </form>

    </DxScrollView>
  </template>            
</DxPopup>

</template>

<script>
import { ref, reactive, onMounted, } from 'vue'
import {
  DxForm,
  DxSimpleItem,
  DxButtonItem,
  DxGroupItem,
  DxEmptyItem
} from 'devextreme-vue/form';
import DxButton from 'devextreme-vue/button';
import DxDataGrid, { 
  DxSelection,
  DxEditing,
  DxColumn,
 DxPaging
} from 'devextreme-vue/data-grid';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import {
  DxRequiredRule,
  DxPatternRule,
} from 'devextreme-vue/validator';
import notify from 'devextreme/ui/notify';
import RawDataService from '../services/RawDataServiceTemplate';
import DataService from '../services/DataServiceTemplate';
import AddSignalForm from '../components/settings-add-signal.vue';
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";

export default {
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxEmptyItem,
    DxButton,
    DxDataGrid,
    DxEditing,
    DxColumn,
    DxPaging,
    DxSelection,
    DxPopup,
    DxScrollView,
    DxRequiredRule,
    DxPatternRule,
    AddSignalForm,
    //BatterySettingsEditor,
  },
  props: {
    name: {
      type: String,
      default: null 
    }
  },
  emits: ['asset-update','signal_selected', 'cancel'],
  setup(props, { emit }) {
    const stErrorCb = err => { notify(err.message, "error", 3000); }
    const modBusbDataService = ref(null);
    const assetsDataService = new RawDataService('masters/assets');
    const nodesDataService = new RawDataService('masters/enfyoGraphNodes');
    const staticsDataService = new RawDataService('statics/tables');
    const signalDataService = new DataService('masters/signals', 'signalId')   

    const nodesList = ref ([]);
    const isAddSignalFormVisible = ref(false);
    const hideAddSignalForm = () => { isAddSignalFormVisible.value = false; }
    const showAddSignalForm = () => { isAddSignalFormVisible.value=true; }
    const isMbConfigVisible = ref(false);
    const signalDS = signalDataService.dataSource;
    const signalList = signalDataService.dataSource;
    const signalForm = ref(null);

    const modbusConf = reactive({ enabled: false });
    const assetData = reactive({
      name: "",
      uuid: null,
      fabricator: "",
      model: "",
      desc: null,
      compType:"",
      isEnabled: 0
    });

    const saveAssetChanges = async () => {
      try{
        assetsDataService.update(assetData.name, assetData).then(res =>{
          if(res.isOk){
            emit('asset-update', { 
              objectType: 'asset',
              key: assetData.name, 
              type:'update', 
              message: res.message||'asset update sent' });
            notify(res.message||"asset updated", "success", 3500)
          }else{
            notify(res.message||"unexpected response", "warn", 3500)
          }
        })
        
      }catch(error){
        stErrorCb(error);
      }
    }

    const refreshSignalGrid = (e) => {
      emit('asset-update', e);
      signalDS.reload();
     return;
      
    }

    const signalRemoveFromDG = async (e) => {
      if(!e.data?.signalId) return ;
      const enfyoPointsService = new RawDataService('sunSpec/config/enfyoPoints');
      const point_id = (await enfyoPointsService.getAll()).find((p)=>p.enfyoSignal_id == e.data.signalId)?.id || 1;
      await enfyoPointsService.update(point_id,{enfyoSignal_id:1 })
     
      emit('asset-update', { 
        objectType: 'signal', 
        key: e.data.signalId, 
        type:'remove', 
        message: 'signal removed from asset' });
      
      signalForm.value.SSPointsDS.reload();
    }

    const showModBusConf = () => { isMbConfigVisible.value=true; }
    const setModbusConfig = async() => {
      try{
        if(!modBusbDataService.value) throw new Error("Conection not found for modbusdata");
        const mbUpdateRes = await modBusbDataService.value.sendPatch('modbusServer', modbusConf);
        if(mbUpdateRes.isOk){
          isMbConfigVisible.value=false;
          return notify(mbUpdateRes.message||'data sent', "success", 3500);
        }
        throw new Error("unknown response saving Modbus Info")
      }catch(error){ 
        isMbConfigVisible.value=false;
        stErrorCb(error); 
      }
    } 
    const clearModbusConfig = async() => {
      try{
        const mbUpdateRes = await modBusbDataService.value.remove('modbusServer');
        resetMbConfigObj();
        isMbConfigVisible.value=false;
        return notify(mbUpdateRes.message||'deletion sent', "success", 3500);
      }catch(error){
        isMbConfigVisible.value=false;
        stErrorCb(error); 
      }
    }
    const loadById = async (name) => {
      
      signalDataService.setFilter({ assetName: name||'null' });
      assetsDataService.getByKey(name).then(res => {
        Object.assign(assetData, res);
        signalDS.reload();
        SSPointsDS.reload();
      }).catch(stErrorCb);
      const promiseNodes = nodesDataService.getAll();
      const promiseNodeFams = staticsDataService.getByKey('graphNodeFamilies');
      Promise.all([promiseNodes, promiseNodeFams]).then( response => {
        const updNodeList = response[0].filter?.(nd => nd.enabled);
        updNodeList.push({ id: null, caption: 'NONE' }); //allow unset from nodes
        const nodeFamiliesList = response[1];
        for(const nd of updNodeList){
          nd.NodeFamily = nodeFamiliesList.find( nf => nf.id==nd.node);
        }
        nodesList.value = updNodeList;
      }).catch(stErrorCb);
      loadMbConfig(name);
      
    }
    const resetMbConfigObj = () => {
      modbusConf.enabled = false;
      modbusConf.assetId = null;
      modbusConf.ipAddress = null;
      modbusConf.port = null;
      modbusConf.description = null;
      modbusConf.unitId = null;
      modbusConf.multpleWordEndianess = 'Little-Endian';
      modbusConf.cycleReadPeriodMS = 1000;
      modbusConf.readOpWaitMS = 5;

    }


    const showSSSettings=ref(true)
    const SSPointsStore = new CustomStore({
      key: 'id',
       loadMode: "raw",
      load: async() => {
        try{
          let newDs = [];
          const SSPointsService = new RawDataService('sunSpec/config/SSPoints');
          const pointList = await SSPointsService.getByKey(assetData.uuid);
          const pointListF= pointList.filter((p)=> 
            (   p.ss_id.includes('ssm_702_') || p.ss_id.includes('ssm_701_') ||
                p.ss_id.includes('ssm_804_') || p.ss_id.includes('ssm_802_') || 
                p.ss_id.includes("ssm_1_")   || !p.ss_id.includes("ssm_")) 
            &&  p.label!=undefined
            &&  p.label!=''
            &&  !p.ss_id.toLowerCase().includes('_sf')
            &&  !p.ss_id.toLowerCase().includes('_l')
            &&  !p.ss_id.toLowerCase().includes('_id')
            &&  !p.label.toLowerCase().includes('category')
            &&  !p.name.toLowerCase().includes('st')
            &&  (p.label.toLowerCase().includes('nameplate')
              || p.label.toLowerCase().includes('type')
              || p.label.toLowerCase().includes('rate')
              || p.label.toLowerCase().includes('rating')
              || p.label.toLowerCase().includes('setting')
              || p.label.toLowerCase().includes('nominal'))) //  &&  p.static=='S'
          
           
          for(const point of pointListF){
            if(point.mandatory=='M')
              point.name='* '+point.name;
            if(point.label.toLowerCase().includes('rating'))
              point.group = 'ratings'
            else if(point.label.toLowerCase().includes('setting'))
              point.group = 'settings'
            newDs.push(point)    
          }
         
          showSSSettings.value=(newDs.length>0);
          return newDs;
        }catch(err) { notify('error: '+err.message, 'error', 4000); return [] }
      },
      update: async(key, data)=>{
        try{
          const SSPointsService = new RawDataService('sunSpec/config/enfyoPoints');
          console.log(data)
          await SSPointsService.update(key,data);
        }catch(err) { notify('error: '+err.message, 'error', 4000); }
      }
    });

    const SSPointsDS = new DataSource({
      store: SSPointsStore,
      paginate: false
    });

    const loadMbConfig =(assetId) => {
      modBusbDataService.value = new RawDataService('masters/assets/'+assetId);
      resetMbConfigObj();
      modBusbDataService.value.getByKey('modbusServer').then(response => {
        Object.assign(modbusConf, response);
      });
    }

    const signalTypeDataService = new RawDataService('statics/tables/signalTypes');
    const signalTypeList = ref([]); 
    signalTypeDataService.getAll().then(sigList =>{
      const typeList = sigList.map(sTypeObj => sTypeObj.id);
      signalTypeList.value = typeList;
    }).catch(stErrorCb);
  
    onMounted(()=>{
      loadById(props.name);
      SSPointsDS.reload()
    })

    const fncSignalDblClick = (row)=> {
      console.log(row.data)
      emit('signal_selected',row)
    }

    return {
      assetData,
      modbusConf,
      isAddSignalFormVisible,
      isMbConfigVisible,
      showModBusConf,
      showAddSignalForm,
      hideAddSignalForm,
      refreshSignalGrid,
      saveAssetChanges,
      signalRemoveFromDG,
      signalTypeList,
      setModbusConfig,
      clearModbusConfig,
      signalDS,
      signalList,
      nodesList,
      loadById,
      signalForm,
      SSPointsDS,
      showSSSettings,
      fncSignalDblClick,

    }
  },
}
</script>

<style>
</style>
